<div *ngIf="participants && participants.length > 0" class="container">
    <div class="gh-details-container mt-2">
        <div class="row info-game position-relative">
            <div *ngIf="isLoading"
                class="cv-loader-container position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
            </div>
            <div class="col-6">
                <div class="mb-2">
                    <span class="color-theUpsideDown font-weight-bold font-size-18" cvLocalizedText langSection="Games"
                        langKey="Game_Details">Game Details</span>
                    <span class="color-theUpsideDown font-weight-bold ml-2">-</span>
                    <span
                        class="color-theUpsideDown font-weight-bold font-size-18 ml-2">{{selectedGame.RuleName}}</span>
                </div>
                <div [hidden]="isLoading || endDate === null">
                    <div class="d-flex align-items-center mb-2">
                        <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                            langSection="Games" langKey="Type">Type</span>
                        <div class="d-flex align-items-center ml-2">
                            <div *ngIf="selectedGame" class="ghGame-icon {{selectedGame.iconClass}}"></div>
                            <span
                                class="color-whaleTail font-weight-bold font-size-14">{{selectedGame.gameTypeName}}</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                        <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                            langSection="Games" langKey="Frequency">Frequency</span>
                        <div *ngIf="selectedGame.GameType !== GameTypeEnum.Brackets">
                            <div [ngSwitch]="historyGame?.IntervalType">
                                <div class="color-whaleTail font-size-14 font-weight-bold ml-2" *ngSwitchCase="0"
                                    cvLocalizedText langSection="Games" langKey="Daily">Daily</div>
                                <div class="color-whaleTail font-size-14 font-weight-bold ml-2" *ngSwitchCase="1"
                                    cvLocalizedText langSection="Games" langKey="Weekly">Weekly</div>
                                <div class="color-whaleTail font-size-14 font-weight-bold ml-2" *ngSwitchCase="2"
                                    cvLocalizedText langSection="Games" langKey="Monthly">Monthly</div>
                            </div>
                        </div>
                        <span *ngIf="selectedGame.GameType === GameTypeEnum.Brackets" cvLocalizedText
                            langSection="Games" langKey="N_A"
                            class="color-whaleTail font-size-14 font-weight-bold ml-2">N/A</span>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                        <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                            langSection="Games" langKey="Participation">Participation</span>
                        <div class="ghr-participants ml-2">
                            <span class="color-whaleTail font-size-14 font-weight-bold count_participants"
                                matTooltipClass="custom-tooltip"
                                matTooltip="{{ historyGame?.AutoJoin ? getLocalizedText('Autojoin_Enabled','Autojoin enabled') : getLocalizedText('Autojoin_Disabled','Autojoin disabled') }}"
                                matTooltipPosition="above" [matTooltipShowDelay]="0">
                                {{ joinedCount }}/{{ sumPlayers }}
                            </span>
                            <span class="lower font-weight-bold font-size-14" [ngClass]="{
                            'greater': isPercentageGreaterThan75
                            }">({{participantsPercentage}}%)</span>
                        </div>
                        <div class="ghr-participants responsive-nowrap">
                            <span
                                #Rewards_Collected
                                class="color-theUpsideDown font-weight-bold font-size-14 ml-2 text-truncate-ellipsis"
                                cvLocalizedText langSection="Games" langKey="Rewards_Collected"
                                matTooltipClass="custom-tooltip"
                                matTooltip="{{ checkTextTruncation(getLocalizedText('Rewards_Collected','Rewards Collected'), 'Rewards_Collected') }}"
                                matTooltipPosition="above" [matTooltipShowDelay]="0">Rewards Collected</span>
                            <span *ngIf="historyGame?.CollectButton"
                                class="color-whaleTail ml-2 font-weight-bold font-size-14">
                                {{ collectedCount }}/{{ countParticipantRewards }}
                                <span class="lower font-weight-bold font-size-14"
                                    [ngClass]="{ 'greater': iscollectedPercentageGreaterThan75 }">
                                    ({{ collectedRewardsPercentage }}%)
                                </span>
                            </span>
                            <span #Collect_Button class="color-whaleTail font-weight-bold font-size-14 ml-2 text-truncate-ellipsis"
                                cvLocalizedText langSection="Games" langKey="Collect_Button_Disabled"
                                *ngIf="!historyGame?.CollectButton"
                                matTooltipClass="custom-tooltip"
                                matTooltip="{{ checkTextTruncation(getLocalizedText('Collect_Button_Disabled','Collect Button disabled'), 'Collect_Button') }}"
                                matTooltipPosition="above" [matTooltipShowDelay]="0">
                                Collect Button disabled
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div [hidden]="isLoading || endDate === null" class="col-6">
                <div class="mb-2 d-flex justify-content-end">
                    <div class="game-details-title">
                        <div class="lastupdate">
                            <p cvLocalizedText langSection="Games_History" langKey="Time_Since_Last_Update">
                                Time since last update
                            </p>
                            <span class="time-lastupdate" [ngClass]="{ 'recently-added': isRecentlyAdded }">
                                {{ timeSinceLastUpdate }}
                            </span>
                            <a class="edit-game-btn" cvLocalizedText langSection="Games_History" langKey="Edit_Game_Settings" (click)="editGame()">Edit Game Settings</a>
                        </div>
                    </div>
                </div>
                <div *ngIf="gameMetric != undefined" class="d-flex align-items-center mb-2 gh-metric">
                    <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                        langSection="Games" langKey="Metric">Metric</span>
                    <span
                        class="color-whaleTail font-size-14 font-weight-bold ml-2">{{gameMetric?.MetricDetail?.Name}}</span>
                    <span class="ml-1"
                        *ngIf="selectedGame.GameType !==  GameTypeEnum.Connect3 && selectedGame.GameType !== GameTypeEnum.Blackout">
                        <span class="color-valyrianSteel font-size-14"> -
                            <span class="color-valyrianSteel font-size-14 mr-1" cvLocalizedText langSection="Games"
                                langKey="Avg">Avg.</span>
                            <span class="color-valyrianSteel font-size-14">{{gameMetric.FormattedCurrentAverage}}</span>
                        </span>
                    </span>
                    <div
                        *ngIf="selectedGame.GameType == GameTypeEnum.Connect3 || selectedGame.GameType == GameTypeEnum.Blackout">
                        <span class="ml-1" *ngIf="getConnect3InitialPosition() as metric">
                            <span class="color-whaleTail font-size-14 font-weight-bold">
                                {{ metric.direction }} {{ metric.formattedData }}
                            </span>
                        </span>
                        <span class="ml-1">
                            <span class="color-valyrianSteel font-size-14">
                                - <span class="color-valyrianSteel font-size-14 mr-1" cvLocalizedText
                                    langSection="Games" langKey="Avg">Avg.</span>
                                <span class="color-valyrianSteel font-size-14">{{gameMetric.FormattedCurrentAverage}}</span>
                            </span>
                        </span>
                        <span class="color-valyrianSteel font-size-14" [ngbPopover]="popoverTemplate" placement="bottom"
                            triggers="hover" popoverClass="custom-popover" container="body">
                            + {{selectedGame.SelectedMetrics.length - 1}} <span cvLocalizedText langSection="Games"
                                langKey="Metrics">metrics</span>
                        </span>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                        langSection="Games" langKey="Qualifier">Qualifier</span>
                    <span *ngIf="qualifier != undefined"
                        class="color-whaleTail font-size-14 font-weight-bold ml-2">{{qualifier.MetricDetail.Abbrev}}</span>
                    <span class="ml-2" *ngIf="qualifier" [ngSwitch]="+qualifier.ComparerType">
                        <span *ngSwitchCase="1" class="color-whaleTail font-size-14 font-weight-bold">{{(qualifier != null ? (" > " + getFormattedData(qualifier.LeftNumber, qualifier.MetricDetail.ConversionType)) : "")}}</span>
                        <span *ngSwitchCase="2" class="color-whaleTail font-size-14 font-weight-bold">{{(qualifier != null ? ( " < " + getFormattedData(qualifier.LeftNumber, qualifier.MetricDetail.ConversionType)) : "" )}}</span>
                        <span *ngSwitchCase=" 3" class="color-whaleTail font-size-14 font-weight-bold">{{(qualifier !=null ? (getLocalizedText('Between','Between') + " " + getFormattedData(qualifier.LeftNumber, qualifier.MetricDetail.ConversionType) + " " + getLocalizedText('And','and') + " " +
                                getFormattedData(qualifier.RightNumber, qualifier.MetricDetail.ConversionType)) : "")}}
                        </span>
                    </span>
                    <div *ngIf="qualifier != undefined" class="d-flex">
                        <span class="color-valyrianSteel font-size-14 ml-1">-&nbsp;</span>
                        <span class="color-valyrianSteel font-size-14 mr-2" cvLocalizedText langSection="Games"
                            langKey="Avg">Avg.</span>
                        <span class="color-valyrianSteel font-size-14">
                            {{qualifier.FormattedCurrentAverage}}
                        </span>
                    </div>
                    <span class="color-whaleTail font-size-14 font-weight-bold ml-2" *ngIf="qualifier == undefined"
                        cvLocalizedText langSection="Games" langKey="None">None</span>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <span class="color-theUpsideDown gh-details-text font-weight-bold font-size-14" cvLocalizedText
                        langSection="Games" langKey="Total_Rewards">Total Rewards</span>
                    <span *ngIf="!noRewards" class="d-flex align-items-center font-size-14 ml-2">
                        <svg class="fill-midas mr-1" width="12px" height="12px">
                            <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                        </svg>
                        <span class="color-whaleTail font-weight-bold">{{sumCoins === 0 ? '--' : sumCoins}}</span>
                        <svg class="fill-dimetapp ml-2 mr-1" width="12px" height="12px">
                            <use [attr.href]="'../App_Themes/clearview-default/icons/utility/xp.svg#xp'">
                            </use>
                        </svg>
                        <span class="color-whaleTail font-weight-bold mr-1">{{ sumXP === 0 ? '--' : sumXP }}</span>
                        <svg class="fill-gem mr-1" width="12px" height="12px">
                            <use [attr.href]="'../App_Themes/clearview-default/icons/utility/gems.svg#gems'">
                            </use>
                        </svg>
                        <span class="color-whaleTail font-weight-bold" cvLocalizedText langSection="Games"
                            langKey="N_A">N/A</span>
                        <svg class="fill-badge ml-2 mr-1" width="12px" height="12px">
                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                        </svg>
                        <span class="color-whaleTail font-weight-bold mr-2">{{ sumBadges === 0 ? '--' : sumBadges }}</span>
                        <div *ngIf="budget?.budgetList?.length > 0 && budget.totalAmount > 0" class="d-flex align-items-center">
                            <span class="color-valyrianSteel">-&nbsp; {{ percentageBudget }}%</span>
                            <span class="color-valyrianSteel ml-1" cvLocalizedText langSection="Games" langKey="Of_Total">of total&nbsp; </span>
                            <svg class="fill-midas mr-1 ml-1" width="12px" height="12px">
                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                            </svg>
                            <span class="color-valyrianSteel" cvLocalizedText langSection="Games" langKey="Budget">Budget</span>
                        </div>
                    </span>
                    <span class="color-whaleTail font-size-14 font-weight-bold ml-1" cvLocalizedText langSection="Games"
                        langKey="No_Rewards_Distributed" *ngIf="noRewards">No rewards distributed</span>
                </div>
            </div>
        </div>
    </div>
    <div class="divider"></div>
    <cv-game-history-breakdown-effectiveness *ngIf="historyGame" [game]="selectedGame" [participants]="participants"
        [intervalSelected]="intervalSelected"
        [isLoadingGameParams]="_loadingGameParams" [historyGame]="historyGame" [metricsHistory]="allMetrics"></cv-game-history-breakdown-effectiveness>
    <div class="divider"></div>
    <div class="row w-100">
        <div class="col-6">
            <cv-health-report-specific-details class="col-sm-12 col-md-6 pl-0" [game]="selectedGame" [endDate]="endDate"
                [gameActions]="gameActions" [participants]="participants" [teamsInfo]="teamsInfo"
                [isLoading]="_loadingGameParams" [historyGame]="historyGame"></cv-health-report-specific-details>
        </div>
        <div class="col-6">
            <cv-health-report-top-performers class="col-sm-12 col-md-6 pl-0" [game]="selectedGame" [endDate]="endDate"
                [isLoading]="_loadingGameParams"></cv-health-report-top-performers>
        </div>
    </div>
    <ng-template #popoverTemplate>
        <div style="max-width: 70rem; width: 70rem;" class="custom-popover-content">
            <ng-container *ngFor="let metricPosition of metricList; let index = index">
                <div *ngIf="metricPosition.Position !== 0">
                    <span class="color-whaleTail font-size-14 popover-content">{{ metricPosition.MetricDetail.Abbrev
                        }}</span>
                    <span class="color-whaleTail font-size-14 popover-content">
                        {{ metricPosition.MetricDetail.DefaultMetricDirection === 0 ? '<' : '>' }} {{
                            getFormattedData(metricPosition?.LeftNumber, metricPosition.MetricDetail.ConversionType) }}
                    </span>
                    <span class="color-valyrianSteel font-size-14">
                        - 
                        <span class="color-valyrianSteel font-size-14" cvLocalizedText langSection="Games" langKey="Avg">
                            Avg.
                        </span>
                        {{metricPosition.FormattedCurrentAverage}}
                    </span>
                    <br />
                </div>
            </ng-container>
        </div>
    </ng-template>
</div>
<div *ngIf="participants == null || participants.length === 0" class="container">
    <div *ngIf="participants == null" class="center-content">
      <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
    </div>
    <div *ngIf="participants && participants.length === 0" class="center-content">
      <span cvLocalizedText langSection="Games" langKey="No_Historical_Data">No Historical Data</span>
    </div>
</div>
